import { c as _c } from "react/compiler-runtime";
import { Badge } from '@onefootprint/ui';
import type { FormattedRegistration } from '../../../../../../onboarding-business-insight.types';
import { statusVariant } from '../../../../constants';
import useRegistrationStatusText from '../../../../hooks/use-registration-status-text';
type RowProps = {
  filing: FormattedRegistration;
};
const Row = t0 => {
  const $ = _c(15);
  const {
    filing: t1
  } = t0;
  const {
    state,
    registrationDate,
    status
  } = t1;
  const t = useRegistrationStatusText();
  let t2;
  if ($[0] !== status || $[1] !== t) {
    t2 = () => {
      if (status && Object.keys(statusVariant).includes(status)) {
        return <Badge variant={statusVariant[status]}>{t(status)}</Badge>;
      }
      return "-";
    };
    $[0] = status;
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const renderStatus = t2;
  let t3;
  if ($[3] !== state) {
    t3 = <td>{state}</td>;
    $[3] = state;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== registrationDate) {
    t4 = <td>{registrationDate}</td>;
    $[5] = registrationDate;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== renderStatus) {
    t5 = renderStatus();
    $[7] = renderStatus;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <td>{t5}</td>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t6) {
    t7 = <>{t3}{t4}{t6}</>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
export default Row;